import script from "./USPTileRibbon.vue?vue&type=script&setup=true&lang=ts"
export * from "./USPTileRibbon.vue?vue&type=script&setup=true&lang=ts"

import "./USPTileRibbon.vue?vue&type=style&index=0&id=3cf17079&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf17079"]])

export default __exports__